export default {
  SET_USER_INFO: '[poster] set user info',
  SET_POSTER_INFO: '[poster] set poster info'
}
